import { render, staticRenderFns } from "./ReadyContents.vue?vue&type=template&id=6747d6b6&scoped=true"
import script from "./ReadyContents.vue?vue&type=script&lang=js"
export * from "./ReadyContents.vue?vue&type=script&lang=js"
import style0 from "./ReadyContents.vue?vue&type=style&index=0&id=6747d6b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6747d6b6",
  null
  
)

export default component.exports